const config = require('../../../../../config/locales_json/packs/private/users/profile.json');
const isosById = require('./isos.json');
const language = $('body').data("language");
const CHILE_COUNTRY_ID = "43";
const CHILE_ISO = "CL";

/*
*
*   C O N E X I O N E S   B A S E   D E   D A T O S
*
*/

var profileNationality = $('#form_profile_nationality')
var profileCountry = $('#form_profile_co')
var profileRegion = $('#form_profile_re')
var profileState = $('#form_profile_st')
var profileCity = $('#form_profile_ci')
var $profileUniversity = $('#form_profile_university')
var $profileCareer = $('#form_profile_career')
var $profileCareerArea = $('#form_profile_career_area')
var $profileCountryStudy = $('#form_profile_country_study')

const addText = getTranslationValue(config, [language, "add_text"],"Agregar ");

if ($profileUniversity.length > 0 && $profileCareer.length > 0 && $profileCareerArea.length > 0) {
  $profileUniversity.selectize({
    sortField: 'text',
    create: false,
    render: {
			option_create: function(query) {
				var listOptions = $("#cont_form_profile_university .selectize-dropdown-content").find(".option")
				if(listOptions.length > 0){
					var classHidden = "hidden"
				} else {
					var classHidden = ""
				}

				return '<div class="create '+classHidden+'">'+addText+'<strong>'+query.input+'</strong>…</div>';
			}
		}
  });

  $profileCareer.selectize({
    create: false,
    sortField: 'text',
    render: {
			option_create: function(query) {
				var listOptions = $("#cont_form_profile_career .selectize-dropdown-content").find(".option")
				if(listOptions.length > 0){
					var classHidden = "hidden"
				} else {
					var classHidden = ""
				}

				return '<div class="create '+classHidden+'">'+addText+'<strong>'+query.input+'</strong>…</div>';
			}
		}
  });

  $profileCareerArea.selectize();

}

// CAMPO NACIONALIDAD
if (profileNationality.length > 0) {
  profileNationality.selectize({
    create: false
  });
}

// FILTRO PAÍS
if (profileCountry.length > 0) {
  profileCountry.selectize({
    create: false
  });
}


// REGIÓN
if (profileRegion.length > 0) {
  profileRegion.selectize({
    sortField: 'text',
    create: false
  });
}

// STATE
if (profileState.length > 0) {
  profileState.selectize({
    sortField: 'text',
    create: false
  });
}

// CITY
if (profileCity.length > 0) {
  profileCity.selectize({
    sortField: 'text',
    create: false
  });
}

/*************
* Pais de residencia (Pregunta de la cual dependen Region, Provincia y Ciudad)
*
* Activacion de campos si en co se tiene un valor de los que permiten mostrar los campos demograficos.
*/
const residenceCountryInput = $('#form_profile_co');

if (residenceCountryInput.length > 0 && residenceCountryInput.hasClass("dynamic_action_field")) {
  activateDemograficQuestions(residenceCountryInput)
}

function activateDemograficQuestions(input){
  // Se obtienen los campos que tienen reglas de la pregunta pais de residencia
  const dataFields = input.attr("data-fields").split(",");
  // Se obtienen los valores de las reglas de la pregunta pais de residencia
  const dataValues = input.attr("data-values").split(";").filter(element => element !== "");
  // Es el valor de la pregunta pais de residencia
  const inputValue = parseInt(input.val());
  // Campos obligatorios
  const isRequiredValues = input.attr("data-required").split(";")

  $.each(dataFields, function(index, value) {
    const valuesRules = dataValues[index].split(",").map(element => parseInt(element));
    const isRequired = isRequiredValues[index];

    const containerFieldTo = $("form#profile-form #cont_form_profile_"+value);

    if (valuesRules.includes(inputValue)){
      switch (value) {
        case "re":
          profileRegion.prop('disabled', false);

          if(isRequired == "true") {
            profileRegion.removeClass("optional");
            containerFieldTo.removeClass("optional");

            addRequiredWords(containerFieldTo);
          } else {
            profileRegion.addClass("optional");
            containerFieldTo.addClass("optional");

            deleteRequiredWords(containerFieldTo)
          }

          countryValue = profileCountry.val();
          regionValue = profileRegion.val();

          if(regionValue.length == 0 && countryValue.length > 0){
            profileRegion[0].selectize.clear();
            profileRegion[0].selectize.clearOptions();
            loadStates(profileRegion[0].selectize, countryValue)
          }

          profileRegion[0].selectize.enable();
          containerFieldTo.removeClass("hidden");

          break;
        case "st":
          profileState.prop('disabled', false);

          if(isRequired == "true") {
            profileState.removeClass("optional");
            containerFieldTo.removeClass("optional");

            addRequiredWords(containerFieldTo);
          } else {
            profileState.addClass("optional");
            containerFieldTo.addClass("optional");

            deleteRequiredWords(containerFieldTo)
          }

          countryValue = profileCountry.val();
          stateValue = profileState.val();

          if(stateValue.length == 0 && countryValue.length > 0){
            profileState[0].selectize.clear();
            profileState[0].selectize.clearOptions();
            loadStates(profileState[0].selectize, countryValue)
          }

          profileState[0].selectize.enable()
          containerFieldTo.removeClass("hidden");

          break;
        case "ci":
          profileCity.prop('disabled', false);

          if(isRequired == "true") {
            profileCity.removeClass("optional");
            containerFieldTo.removeClass("optional");

            addRequiredWords(containerFieldTo);
          } else {
            profileCity.addClass("optional");
            containerFieldTo.addClass("optional");

            deleteRequiredWords(containerFieldTo)
          }

          countryValue = profileCountry.val();
          cityValue = profileCity.val();

          if(cityValue.length == 0 && countryValue.length > 0){
            profileCity[0].selectize.clear();
            profileCity[0].selectize.clearOptions();
            loadCities(profileCity[0].selectize, countryValue)
          }

          profileCity[0].selectize.enable()
          containerFieldTo.removeClass("hidden");

          break;
        default:
          break;
      }
    }
  });
}

function addRequiredWords(containerFieldTo){
  hintText = containerFieldTo.find(".hint-field-text");
  string = hintText.text();

  hintText.text(`Obligatorio | ${string.replace("Obligatorio |", "")}`)
}

function deleteRequiredWords(containerFieldTo){
  hintText = containerFieldTo.find(".hint-field-text");
  string = hintText.text();

  hintText.text(string.replace("Obligatorio |", ""))
}

/*************
* Nivel de estudio (Pregunta de la cual dependen Pais de estudio, Universidad, Carrera, Areas de Carrera y Estado de estudio)
*
* Activacion de campos de estudio si en el study_level se tiene un valor de los que permiten mostrar los campos de estudio.
*/
const studyLevelInput = $('#form_profile_study_level');
const studyLevelTechInput = $('#form_profile_study_level_tech');

if (studyLevelInput.length > 0 && studyLevelInput.hasClass("dynamic_action_field")) {
  activateStudyQuestions(studyLevelInput)
}

if (studyLevelTechInput.length > 0 && studyLevelTechInput.hasClass("dynamic_action_field")) {
  activateStudyQuestions(studyLevelTechInput)
}

function activateStudyQuestions(studyLevelInput){
  // Se obtienen los campos que tienen reglas de la pregunta study_level
  const dataFields = studyLevelInput.attr("data-fields").split(",");
  // Se obtienen los valores de las reglas de la pregunta study_level 
  const dataValues = studyLevelInput.attr("data-values").split(";").filter(element => element !== "");
  // Por regla de negocio necesitamos obtener la posicion en el array de la pregunta country_study
  const positionRules = dataFields.indexOf("country_study");
  // Buscamos los valores de la regla en la posicion que corresponde
  const valuesRules = dataValues[positionRules].split(",");
  // Se transforman los valores de la regla a int
  const valuesRulesInt = valuesRules.map(element => parseInt(element));

  // Es el valor de la pregunta study_level
  const valueStudyLevel = parseInt(studyLevelInput.val());

  // Si el valor de la pregunta study_level esta dentro de los valores de las reglas habilita los campos. De lo contrario se cumplen las reglas por defecto del HTML
  if (valuesRulesInt.includes(valueStudyLevel)){
    $profileCountryStudy.prop('disabled', false).removeClass("optional");
    $profileUniversity.prop('disabled', false).removeClass("optional");
    $profileUniversity[0].selectize.enable()
    $profileCareer.prop('disabled', false).removeClass("optional");
    $profileCareer[0].selectize.enable()
    $profileCareerArea.prop('disabled', false).removeClass("optional");
    $profileCareerArea[0].selectize.enable()

    $("#cont_form_profile_study_state").find("input").removeClass("optional")
  }
}

/*************
* País de Estudio (Pregunta de la cual dependen Universidad y Carrera)
*
* Aplica selectize para buscar en la base de datos del país si este es Chile
* de lo contrario no lo activa.
*
* Se crea variable isDependCountyStudyQuestion para validar si las preguntas Universidad y Carrera
* cargan por default sus selectize o si depende de la pregunta country study.
* Esto con el fin de poder tener independencia de validaciones si no existe la pregunta country study
*/
// Por defecto es false para que se activen los selectize de Universidad y Carrera
var isDependCountyStudyQuestion = false;

// Si el campo country_study existe
if ($profileCountryStudy.length > 0) {
  isDependCountyStudyQuestion = true

  $profileCountryStudy.selectize({
    // sortField: 'text',
    onChange: function(countryID) {
      // Limpia campos universidad y carrera
      clean_study_inputs();

      // Se traen los datos y se arman los selectize
      if (countryID !== ""){
        loadUniversities($profileUniversity, countryID);
        loadCareers($profileCareer, countryID);
        loadCareerAreas($profileCareerArea)
        loadStudyState("cont_form_profile_study_state", countryID)
      }
    }
  });
}


// Limpia los inputs de universidad y carrera
function clean_study_inputs(){
  profileUniversity = $profileUniversity[0].selectize;
  profileCareer = $profileCareer[0].selectize;
  profileUniversity.clear();
  profileUniversity.clearOptions();
  profileUniversity.disable();
  profileCareer.clear();
  profileCareer.clearOptions();
  profileCareer.disable();
}

$(function() {
  handleDynamicActionsOnStart();
  handleDynamicActionForStudyStateOnStart();
});

// handleDynamicActionsOnStart()

function handleDynamicActionsOnStart(){
  var dynamicActionFields = $("form#profile-form select.dynamic_action_field");

  $.each(dynamicActionFields, function(index, value) {    
    var fieldValue = $(value).val();
    var types = $(value).attr("data-type").split(",");
    var fieldsConditions = $(value).attr("data-fields").split(",");
    var valuesConditions = $(value).attr("data-values").split(";");
    var optionsToActivateAtt = $(value).attr("data-options-activate");
    
    $.each(types, function(index, value) {
      var type = value;
      var $thisValuesConditions = valuesConditions[index].split(",");

      if (type == "dynamic-activate-options") {
        var optionsToActivate = optionsToActivateAtt.split(";")[index].split(",");
        
        if ($thisValuesConditions.includes(fieldValue)) {
          $.each(optionsToActivate, function(_, value) {
            $("#cont_form_profile_"+ fieldsConditions[index] +" .option_"+value).removeClass("hidden");
          });
        } else {
          $.each(optionsToActivate, function(_, value) {
            const containerOption = $("#cont_form_profile_"+ fieldsConditions[index] +" .option_"+value);
            containerOption.addClass("hidden");

            const containerInput = containerOption.find('input');
            if (containerInput.length > 0) {
              if ((containerInput.prop('type') == 'radio' || containerInput.prop('type') == 'checkbox') && containerInput.prop('checked')) containerInput.prop('checked', false);
            }
          })
        }
      }
    });
  });
} 


$("form#profile-form").on("change", "select.dynamic_action_field", function(e, fromEvent) {
  e.preventDefault();

  var fieldValue = $(this).val();
  var types = $(this).attr("data-type").split(",");
  var fieldsConditions = $(this).attr("data-fields").split(",");
  var valuesConditions = $(this).attr("data-values").split(";");
  var isRequiredConditions = $(this).attr("data-required").split(";");
  var optionsToActivateAtt = $(this).attr("data-options-activate");
  
  $.each(types, function(index, value) {
    var type = value;
    var $thisValuesConditions = valuesConditions[index].split(",");
    var containerFieldTo = $("form#profile-form #cont_form_profile_"+fieldsConditions[index]);
    var isRequired = isRequiredConditions[index];

    if(type == "dynamic-activate" && $thisValuesConditions.includes(fieldValue)) {
      containerFieldTo.removeClass("hidden").removeClass("optional");

      if(containerFieldTo.attr("id") == "cont_form_profile_country_study"){
        if (!containerFieldTo.find('select').val()) activeDefaultStudy(containerFieldTo, isRequired);

        if(!isRequired) {
          containerFieldTo.addClass("optional");
        }
      }

      if(containerFieldTo.attr("id") == "cont_form_profile_re" || containerFieldTo.attr("id") == "cont_form_profile_st" || containerFieldTo.attr("id") == "cont_form_profile_ci"){
        const countryID = profileCountry.val();
        activeSelectizeByCountry(containerFieldTo, countryID, isRequired);

        if(!isRequired) {
          containerFieldTo.addClass("optional");
        }
      }

      if(containerFieldTo.attr("id") == "cont_form_profile_study_state") {
        containerFieldTo.find('input:checked').prop('checked', false);
        if (isRequired) containerFieldTo.find('input').removeClass('optional');
      }
    } else if (type == "dynamic-activate-options") {
      var optionsToActivate = optionsToActivateAtt.split(";")[index].split(",");
      
      if ($thisValuesConditions.includes(fieldValue)) {
        $.each(optionsToActivate, function(_, value) {
          $("#cont_form_profile_"+ fieldsConditions[index] +" .option_"+value).removeClass("hidden");
        });
      } else {
        $.each(optionsToActivate, function(_, value) {
          const containerOption = $("#cont_form_profile_"+ fieldsConditions[index] +" .option_"+value);
          containerOption.addClass("hidden");

          const containerInput = containerOption.find('input');
          if (containerInput.length > 0) {
            if ((containerInput.prop('type') == 'radio' || containerInput.prop('type') == 'checkbox') && containerInput.prop('checked')) containerInput.prop('checked', false);
          }
        })
      }
    } else {
      if(containerFieldTo.attr("id") == "cont_form_profile_country_study"){
        const containersToDeactivate = ["university", "career", "study_state", "career_area"];
      
        $.each(containersToDeactivate, function(index, value) {
          const containerToDeactivate = $("form#profile-form #cont_form_profile_"+value);
          deactivateSelectize(containerToDeactivate);

          if(value == "study_state"){
            deactivateRadio(containerToDeactivate);
          }
        });

        deactivateSelectize(containerFieldTo);
      } else if (containerFieldTo.attr("id") == "cont_form_profile_study_state"){
        deactivateRadio(containerFieldTo);
      } else {
        deactivateSelectize(containerFieldTo);
      }
    }
  });
});

$("form#profile-form").on("change", '#cont_form_profile_study_state', function (e, fromEvent) {
  e.preventDefault();
  var currentInput = $(e.target);
  handleDynamicActionForOptions(currentInput)
})

function handleDynamicActionForStudyStateOnStart() {
  var questionInputChecked = $('#cont_form_profile_study_state'+' input[type="radio"]:checked');
  if (questionInputChecked.length < 1) return;
  handleDynamicActionForOptions(questionInputChecked);
}

function handleDynamicActionForOptions(option){
  var fieldValue = option.val();
  var fieldName = option.attr("data-question");
  var types = option.attr("data-type").split(",");
  var actionIds = option.attr("data-target-action").split(",");
  var fieldsConditions = option.attr("data-fields").split(",");
  var conditioningQuestions = option.attr("data-conditioning").split(";");

  $.each(actionIds, function(index, value) {
    const conditionalActionType = types[index];
    const currentConditioningQuestions = conditioningQuestions[index].split(',');
    const actionId = value;

    if (conditionalActionType == 'dynamic-render') {
      var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content'); 
      let conditionalValues = { [fieldName]: fieldValue };

      for (const fieldForm of currentConditioningQuestions) {
        const questionInput = $('#form_profile_'+fieldForm);

        let value = undefined;
        if (questionInput.length > 0) value = questionInput.val();
        
        if (questionInput.length < 1 && !value) {
          const questionInputChecked = $('#cont_form_profile_'+fieldForm+' input[type="radio"]:checked');
          if (questionInputChecked.length > 0) value = questionInputChecked.val();
        }

        if (!value) {
          conditionalValues = undefined;
          break;
        }
        conditionalValues = {...conditionalValues, [fieldForm]: value};
      }

      if (conditionalValues) {
        $.ajax({
          type: "POST",
          url: '/settings/questions',
          dataType: 'script',
          data: {
            target_action_id: actionId,
            option_id: fieldValue,
            conditional_action_type: conditionalActionType,
            conditional_values: conditionalValues,
            authenticity_token: AUTH_TOKEN
          }
        });
      }
    }

    if (conditionalActionType == 'dynamic-remove') {
      const fieldToRemove = fieldsConditions[index];
      $('#cont_form_profile_'+fieldToRemove).remove();
    }
  });
}

function activeDefaultStudy(containerInput, isRequired){
  const countryStudy =  activateSelectize(containerInput, "select#form_profile_country_study", isRequired); 
  loadStudyCountries(countryStudy[0].selectize)
}

function activeSelectizeByCountry(containerInput, countryID, isRequired){
  const inputId = containerInput.attr("id").replace("cont_", "")
  const inputDemographic =  activateSelectize(containerInput, "select#"+inputId, isRequired); 

  switch (inputId) {
    case "form_profile_re":
      loadRegions(inputDemographic[0].selectize, countryID)
      break;
    case "form_profile_st":
      loadStates(inputDemographic[0].selectize, countryID)
      break;
    case "form_profile_ci":
      loadCities(inputDemographic[0].selectize, countryID)
      break;
    default:
      break;
  }

  if(isRequired == "true"){
    inputDemographic.removeClass("optional")
  } else {
    inputDemographic.addClass("optional");
  }
}

function activateSelectize(containerInput, input, isRequired){
  const selectAnOptionText = getTranslationValue(config, [language, "select_an_option"],"Selecciona una opción");

  // Buscamos el input
  const selectizeInput = containerInput.find(input)

  if (selectizeInput.length > 0){
      selectizeInput.removeAttr("disabled")

      if(isRequired == "true"){
        selectizeInput.removeClass("optional")
      } else {
        selectizeInput.addClass("optional")
      }

      // Se activa el selectize del input
      const selectizeOptions = { create: false, placeholder: selectAnOptionText }
      if (selectizeInput.attr("id") != "form_profile_country_study") selectizeOptions.sortField = 'text';
      $(selectizeInput).selectize(selectizeOptions);
  
      // Limpieza del selectize
      selectizeInput[0].selectize.enable();
      selectizeInput[0].selectize.clear();
      selectizeInput[0].selectize.clearOptions();
  }

  return selectizeInput
}

function deactivateSelectize(containerFieldTo){
  containerFieldTo.addClass("hidden").addClass("optional");
  containerFieldTo.find("select").addClass("optional");
  containerFieldTo.find("select").attr("disabled", "disabled");
  if (containerFieldTo.find('select').val()) containerFieldTo.find('select').val('');
}

function deactivateRadio(containerFieldTo){
  containerFieldTo.addClass("hidden").addClass("optional");
  containerFieldTo.find("input").addClass("optional");
  containerFieldTo.find("input").attr("disabled", "disabled");
}

function loadStudyState(inputStringID, countryID){
  const containerStudyState = $("#" + inputStringID);
  containerStudyState.removeClass("hidden").removeClass("optional");
  containerStudyState.find("input").removeClass("optional");
  containerStudyState.find("input").removeAttr("disabled");
  containerStudyState.find("input").removeAttr("checked");
}

/*************
  * 
  *   CARGA DE DATOS
  *   Metodos que permiten la busqueda de los distintos datos necesarios y su implementacion en el DOM
  * 
  */

function loadStudyCountries(input){
  $.ajax({
      url: '/settings/countries',
      type: 'GET',
      dataType: 'json',
      success: function(results) {                
          if (results.data.length > 0){                    
              $.each(results.data, function(index, value) {
                  input.addOption({value: value['id'], text: value['nicename'] });
              });              
          }
      },
      error: function (request, status, error) {
          
      }
  });
}

// Buscamos las universidades según el país
function loadUniversities(input, countryID){
  $.ajax({
    url: '/settings/universities/' + countryID,
    type: 'GET',
    dataType: 'json',
    success: function(results) {
      if(results.data.length > 0){
        const containerFieldTo = input.parent().parent();

        // Rellenando los selects
        input.removeAttr("disabled")
        input.removeClass("optional")
        profileUniversity = input[0].selectize;
        profileUniversity.enable();
        profileUniversity.clear();
        profileUniversity.clearOptions();
        $.each(results.data, function(index, value) {
          profileUniversity.addOption({value: value['id'], text: value['name'] });
        });
        
        containerFieldTo.removeClass("hidden").removeClass("optional");

      } else {
        const containerFieldTo = input.parent().parent();
        containerFieldTo.addClass("hidden");
        containerFieldTo.find("select").addClass("optional");
        containerFieldTo.find("select").attr("disabled", "disabled");
      }

    },
    error: function (request, status, error) {
      clean_study_inputs();
    }
  });
}

// Buscamos las carreras según el país
function loadCareers(input, countryID){
  $.ajax({
    url: '/settings/careers_country/' + countryID,
    type: 'GET',
    dataType: 'json',
    success: function(results) {
      if(results.data.length > 0){
        const containerFieldTo = input.parent().parent();

        // Rellenando los selects
        input.removeAttr("disabled")
        input.removeClass("optional")
        profileCareer = input[0].selectize;
        profileCareer.enable();
        profileCareer.clear();
        profileCareer.clearOptions();
        $.each(results.data, function(index, value) {
          profileCareer.addOption({value: value['id'], text: value['name'] });
        });

        containerFieldTo.removeClass("hidden").removeClass("optional");

      } else {
        const containerFieldTo = input.parent().parent();
        containerFieldTo.addClass("hidden");
        containerFieldTo.find("select").addClass("optional");
        containerFieldTo.find("select").attr("disabled", "disabled");
      }

    },
    error: function (request, status, error) {
      clean_study_inputs();
    }
  });
}

function loadCareerAreas(input){
  $.ajax({
    url: '/settings/career_areas',
    type: 'GET',
    dataType: 'json',
    success: function(results) {
      if(results.data.length > 0){
        const containerFieldTo = input.parent().parent();

        // Rellenando los selects
        input.removeAttr("disabled")
        input.removeClass("optional")
        profileCareerArea = input[0].selectize;
        profileCareerArea.enable();
        profileCareerArea.clear();
        profileCareerArea.clearOptions();
        $.each(results.data, function(index, value) {
          profileCareerArea.addOption({value: value['id'], text: value['name'] });
        });

        containerFieldTo.removeClass("hidden").removeClass("optional");

      } else {
        const containerFieldTo = input.parent().parent();
        containerFieldTo.addClass("hidden");
        containerFieldTo.find("select").addClass("optional");
        containerFieldTo.find("select").attr("disabled", "disabled");
      }

    },
    error: function (request, status, error) {
      
    }
  });
}

function loadRegions(input, countryID){
  $.ajax({
      url: '/settings/regions/' + countryID,
      type: 'GET',
      dataType: 'json',
      success: function(results) {              
          if (results.data.length > 0){                    
              $.each(results.data, function(index, value) {
                  input.addOption({value: value['id'], text: value['name'] });
              });              
          }
      },
      error: function (request, status, error) {
          
      }
  });
}

function loadStates(input, countryID){
  $.ajax({
      url: '/settings/states/' + countryID,
      type: 'GET',
      dataType: 'json',
      success: function(results) {                
          if (results.data.length > 0){                    
              $.each(results.data, function(index, value) {
                  input.addOption({value: value['id'], text: value['name'] });
              });              
          }
      },
      error: function (request, status, error) {
          
      }
  });
}

function loadCities(input, countryID){
  $.ajax({
      url: '/settings/cities/' + countryID,
      type: 'GET',
      dataType: 'json',
      success: function(results) {                
          if (results.data.length > 0){                    
              $.each(results.data, function(index, value) {
                  input.addOption({value: value['id'], text: value['name'] });
              });              
          }
      },
      error: function (request, status, error) {
          
      }
  });
}

/*************
* FIN Pais de estudio - Universidad


/*************
* Envío de formulario
*
* Detiene la ejecucion del formulario
* si no hay errores lo envía, de lo contrario muestra los mensajes de error.
*
*/
$("#profile-form .save-button").on("click", function(e){
  e.preventDefault();

  var form = check_inputs_form();

  if(!form){
    return false;
  } else {
    const successText = getTranslationValue(config, [language, "success_text"],"Guardando información...");
    $("#profile-form").addClass("disabled")
    $(this).text(successText)
    $("#profile-form").submit();
  }
})

function check_inputs_form(){
  var error = 0;
	var container = $('#profile-form .card-body');
	var inputs = container.find($("input").not(".optional"));
  var selects = container.find($("select").not(".optional"));
  const errorText = getTranslationValue(config, [language, "check_inputs_error_text"],"Debes completar este campo");

	inputs.each(function() {
    var inputName = $(this).attr('name');
    var inputType = $(this).attr('type');
    var contInput = $(this).parent().parent();
    contInput.find('.err-msg').remove();

    if(inputName != null && inputName != "") {
      if (inputType == "radio" || inputType == "checkbox") {
        inputName = $(this).attr('name');
        var isChecked = $('input[name="'+ inputName +'"]:checked').length;

        contInput = $(this).parent().parent().parent();
        contInput.find('.err-msg').remove();

        if (isChecked == 0) {
          contInput.append('<div class="col-lg-3 col-xl-3 col-form-label err-msg"></div><div class="col-lg-9 col-xl-9 err-msg"><div class="alert alert-custom alert-outline-danger" role="alert"><div class="alert-icon"><i class="flaticon-warning"></i></div><div class="alert-text">'+errorText+'</div></div></div></div>');
          error++;
        }
      } else if (inputType == "text" || inputType == "number" || inputType == "hidden") {
        contInput.find('.err-msg').remove();

        if (!$(this).val()) {
          contInput.append('<div class="col-lg-3 col-xl-3 col-form-label err-msg"></div><div class="col-lg-9 col-xl-9 err-msg"><div class="alert alert-custom alert-outline-danger" role="alert"><div class="alert-icon"><i class="flaticon-warning"></i></div><div class="alert-text">'+errorText+'</div></div></div></div>');

          error++;
        }
      }
    }
  })

  selects.each(function() {
    var inputName = $(this).attr('name');
    var contInput = $(this).parent().parent();
    contInput.find('.err-msg').remove();

    if(inputName != null && inputName != "") {
      if (!$(this).val()) {
        contInput.append('<div class="col-lg-3 col-xl-3 col-form-label err-msg"></div><div class="col-lg-9 col-xl-9 err-msg"><div class="alert alert-custom alert-outline-danger" role="alert"><div class="alert-icon"><i class="flaticon-warning"></i></div><div class="alert-text">'+errorText+'</div></div></div></div>');
        error++;
      }
    }
  })

  // Validación de inputs opcionales que tengan validación especial
  var specialValidationInputs = container.find("input[data-validation-type].optional");
  specialValidationInputs.each(function () {
    var contInput = $(this).parent().parent();
    contInput.find('.err-msg').remove();

    var errorMsg = validateSpecialInputs(this);
    if (errorMsg != "") {
      contInput.append('<div class="col-lg-3 col-xl-3 col-form-label err-msg"></div><div class="col-lg-9 col-xl-9 err-msg"><div class="alert alert-custom alert-outline-danger" role="alert"><div class="alert-icon"><i class="flaticon-warning"></i></div><div class="alert-text">'+errorMsg+'</div></div></div></div>');

      error++;
    }
  })

  return error == 0 ? true : false;
}


/*************
* Mascaras para los field inputs
*
*/

const inputPhone = document.querySelector("#form_profile_phone");

if ($("#form_profile_phone").length > 0){
  intlTelInput(inputPhone, {
    initialCountry: "CL",
    preferredCountries: ["CL", "PE", "AR", "CO", "EC", "MX", "VE", "BO", "PA", "GT", "CR", "ES", "SV", "UY", "DO", "HN", "PY", "NI", "BR", "US"],
    autoHideDialCode: false,
    nationalMode: false
  });

  $('#form_profile_phone').on('focus', function(){
    var $this = $(this),
        // Get active country's phone number format from input placeholder attribute
        activePlaceholder = $this.attr('data-maskara'),
        // Convert placeholder as exploitable mask by replacing all 1-9 numbers with 0s
        newMask = activePlaceholder.replace(/[1-9]/g, "0");

    // Init new mask for focused input
    $this.mask(newMask);
  });
}

if (profileCountry.length > 0){
  profileCountry.on("change", function () {
    const residenceCountryValue = profileCountry.val();
    const phoneInput = $("#form_profile_phone")

    try {
      const oldDialCode = intlTelInput(inputPhone).getSelectedCountryData()['dialCode'];

      if (phoneInput.length > 0 && residenceCountryValue.length > 0 && phoneInput.val() == '+'+oldDialCode){
        const selectedIso = getIsoByCountryId(residenceCountryValue);
        intlTelInput(inputPhone).setCountry(selectedIso);
        const selectedCountryDialCode = intlTelInput(inputPhone).getSelectedCountryData()['dialCode'];
        
        if (!selectedCountryDialCode) return;
        
        intlTelInput(inputPhone).setNumber('+' + selectedCountryDialCode); 
      }
    } catch (error) {
      console.error(error)
    }
})
}


$('#form_profile_document_type').on("change", function(){
  var selectDoc = $(this);

  setMaskDocumentId();
});

$('#form_profile_nationality').on("change", function(){
  var selectDoc = $(this);

  setMaskDocumentId();
});

setMaskDocumentId();


/*************
* Calendario para la fecha de nacimiento
*
*/
$('#form_profile_birthdate').datepicker({
  todayBtn: "linked",
  endDate: '-17y',
  language: 'es',
  format: 'yyyy-mm-dd',
  clearBtn: true,
  templates: {
      leftArrow: '<i class=\"la la-angle-left\"></i>',
      rightArrow: '<i class=\"la la-angle-right\"></i>'
  }
}).on('hide', function(event){
  var dateText = event.target.value; // Obtener el valor del campo de fecha
  var selectedDate = new Date(dateText);
  
  if (!isValidDate(selectedDate)) {
    alert('La fecha ingresada no es válida. Por favor, seleccione una fecha válida.');
    $('#form_profile_birthdate').val('');
  }
});

function isValidDate(date) {
  var minDate = new Date('1950-01-01');
  var maxDate = new Date('2010-12-31');
  return date >= minDate && date <= maxDate;
}

function setMaskDocumentId(){
  if ($('#form_profile_document_type').val() == "1" && $('#form_profile_nationality').val() == CHILE_COUNTRY_ID){
    $('input#form_profile_document_id').mask('MZ.ZZZ.ZZZ-K',{translation:  {
        'M': {pattern: /[0-9]/, optional: true},
        'Z': {pattern: /[0-9]/},
        'K': {pattern: /[0-9Kk]/},
      },
      reverse: true
    });
  }else{
    $('input#form_profile_document_id').unmask();
  }
}

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;
  
	let currentTranslation;
	let firstIteration = true;
  
	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {
      
      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}
	
	return currentTranslation;
}

function getIsoByCountryId(id){
  if (!isosById || !isosById["isos"]) return CHILE_ISO;
  
  const filterIsos = isosById["isos"].filter(function(iso){return iso.id == id;});
  if (filterIsos.length === 0 || !filterIsos[0] || !filterIsos[0].iso) return CHILE_ISO;

  return filterIsos[0].iso;
}

function validateSpecialInputs(input) {
  const specialValidationType = $(input).data('validation-type');
  const inputValue = $(input).val().trim();

  if (!inputValue || !specialValidationType) return "";

  const locale = $('body').data("language");
  const urlRegex = /^(https?|http?):\/\/[^\s/$.?#].[^\s]*$/
  const emailRegex = /\b[\w+\-.]+@[a-z\d\-.]+\.[a-z]+\b/

  if (specialValidationType == "url" && !urlRegex.test(inputValue)) {
    const errorMsg = { "es": "Debe ingresar una url valida", "en": "You must enter a valid URL.", "pt": "Você deve inserir uma URL válida" };
    return errorMsg[locale] || "Debe ingresar una url valida";

  } else if (specialValidationType == "email" && !emailRegex.test(inputValue)) {
    const errorMsg = { "es": "Debe ingresar un email valido", "en": "You must enter a valid email", "pt": "Você deve inserir um e-mail válido" };
    return errorMsg[locale] || "Debe ingresar un email valido";

  } else {
    return "";
  }
}

